import { render } from "./Edit.vue?vue&type=template&id=3e89123b"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Targets/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e89123b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e89123b', __exports__)) {
    api.reload('3e89123b', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=3e89123b", () => {
    api.rerender('3e89123b', render)
  })

}


export default __exports__